<script setup lang="ts">
import * as zagRadio from "@zag-js/radio-group";
import { normalizeProps, useMachine } from "@zag-js/vue";
import { computed, watch } from "vue";
import type { Option } from "../../types/shared";

const emit = defineEmits(["update"]);
interface Props {
	name?: string;
	values: Option[];
	initialValue?: string;
	disabled?: boolean;
}

const { name, values, initialValue, disabled } = defineProps<Props>();

const [state, send] = useMachine(
	zagRadio.machine({
		id: (Math.random() + 1).toString(36).substring(7),
		value: initialValue,
		disabled: disabled,
		onValueChange: ({ value }) => emit("update", value)
	}) as any
);

const api = computed(() => zagRadio.connect(state.value as any, send, normalizeProps));

watch(
	() => initialValue,
	() => {
		if (initialValue) api.value.setValue(initialValue);
	}
);
</script>

<template>
	<div v-bind="api.rootProps" class="flex flex-col gap-2">
		<div v-for="option in values" :key="option.label">
			<label
				v-bind="api.getItemProps({ value: option.value })"
				class="flex gap-2 items-center cursor-pointer w-fit"
			>
				<span
					class="w-[22px] h-[22px] m-0.5 border-2 border-black-light rounded-full flex justify-center items-center"
				>
					<span
						class="w-[12px] flex h-[12px] bg-black-light rounded-full transition-opacity"
						:class="[api.value === option.value ? 'opacity-100' : 'opacity-0']"
					/>
				</span>
				<span
					v-bind="api.getItemTextProps({ value: option.value })"
					class="text-base"
					:class="{
						'font-bold': api.value === option.value
					}"
				>
					{{ option.label }}
				</span>
				<input v-bind="api.getItemHiddenInputProps({ value: option.value })" :name="name" />
				<div v-bind="api.getItemControlProps({ value: option.value })" />
			</label>
		</div>
	</div>
</template>
